const CONTAINER_TITLE = [
  'Intro',
  'Skills',
  'Works',
  'Experiences',
  'About',
  'Contact',
]

const WORK_FILTERS = [
  'All',
  'ReactJS',
  'NextJs',
  'Tailwindcss',
  'GraphQL',
  'Firebase',
  'MaterialUI',
]

/* exports */
export { CONTAINER_TITLE, WORK_FILTERS }
